<template>
    <div class="monitor-box" v-if="(accInfo.erpType===1||accInfo.erpType===2)&&isShow">
        <el-popover
            placement="top"
            title="ERP同步状态"
            width="400"
            trigger="hover">
            <div  class="data-status-cnt">
                <ul class="synchro-desc">
                    <li>价格同步：<span :class="dataStatus?'normal':'abnormal'">{{dataStatus?'正常':'异常'}}</span></li>
                    <li>库存同步：<span :class="dataStatus?'normal':'abnormal'">{{dataStatus?'正常':'异常'}}</span></li>
                    <li>会员同步：<span :class="dataStatus?'normal':'abnormal'">{{dataStatus?'正常':'异常'}}</span></li>
                </ul>
                <p class="describe" v-if="dataStatus">
                    若同步状态为断开，您的价格、库存、会员同步都将与ERP失去连接，导致订单无法销售、会员无法同步等问题。
                </p>
                <p class="describe" v-else style="color:#303030">
                    服务已断开，请联系信息部或ERP售后同事协助开启服务器统一接口平台。
                </p>
            </div>
            <span class="data-status" :class="dataStatus?'normal':'err'" slot="reference">数据同步</span>
        </el-popover>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { getSyncErpData } from '@/module/apis/user'
import MC from '@/module/MC'
export default {
  name: 'Monitor',
  data () {
    return {
      dataStatus: true,
      isAlert: false,
      notify: null,
      isShow: true
    }
  },
  computed: {
    ...mapState('common', ['accInfo'])
  },
  created () {
    const { userInfo: { merCode } } = MC.config
    this.merCode = merCode
    if (this.accInfo.erpType === 1 || this.accInfo.erpType === 2) {
      this.loadSyncErpUnifiedData()
      this.Interval = setInterval(() => {
        this.loadSyncErpUnifiedData()
      }, 10000)
    }
  },
  methods: {
    async loadSyncErpUnifiedData () {
      try {
        await getSyncErpData(this.merCode)
        this.isShow = true
        this.dataStatus = true
        if (this.notify) {
          this.notify.close()
        }
      } catch (error) {
        if (error.code === '20013') {
          this.isShow = true
          if (!this.isAlert) {
            this.notifyMsg()
          }
        } else {
          this.isShow = false
        }
        this.dataStatus = false
        console.log(error)
      }
    },
    notifyMsg () {
      this.notify = this.$notify.error({
        title: '同步异常',
        duration: 0,
        offset: 40,
        // message: '同步状态已断开，您的价格、库存、会员同步已与ERP失去连接，订单将无法销售、会员无法同步；请联系信息部或ERP售后协助开启服务器统一接口平台。',
        dangerouslyUseHTMLString: true,
        message: `<div class="custom-notify"><p>同步状态已断开，您的价格、库存、会员同步已与ERP失去连接，订单将无法销售、会员无法同步；请联系信息部或ERP售后协助开启服务器统一接口平台。</p><div class="notify-btn"><button type="button" class="el-button el-button--primary el-button--mini" ><span>我知道了</span></button></div></div></div>`
      })
      this.isAlert = true
      this.notify.$el.querySelector('button').onclick = () => {
        // 点击后关闭notify 不需要的话可删掉
        this.notify.close()
      }
    }
  }
}
</script>
<style lang="scss">
$normal:#73D66B;
$abnormal:#F13A3A;
.monitor-box{
    display: inline-block;
    height: 28px;
    line-height: 28px;
    .data-status{
        line-height: 28px;
        font-size: 14px;
        color: #fff;
        margin-top: 2px;
        position: relative;
        &.normal{
            &::before{
                content: " ";
                width: 12px;
                height: 12px;
                background: $normal;
                border-radius: 50%;
                position: absolute;
                left: -20px;
                top: 50%;
                margin-top: -6px;
              }
        }
        &.err{
              &::before{
                 content: " ";
                width: 12px;
                height: 12px;
                background: $abnormal;
                border-radius: 50%;
                position: absolute;
                left: -20px;
                top: 50%;
                margin-top: -6px;
              }
        }
    }
}
 .data-status-cnt{
        .synchro-desc{
            display: flex;
            justify-content: space-between;
            color: #4A4A4A;
            font-size: 12px;
            list-style: none;
            .normal{
                color: $normal;
            }
            .abnormal{
                color: $abnormal;
            }
        }
        .describe{
            color: #B5B5B5;
            font-size: 12px;
            margin-top: 15px;
        }
    }

.custom-notify{
    p{
        font-size: 14px;
        color: #303030;
        margin:0 0 10px;
    }
    .notify-btn{
        text-align: right;
    }
}
</style>


// WEBPACK FOOTER //
// src/js/module/components/monitor/index.vue